/* Lunoor v4 — homepage section behaviour (progressive enhancement).
   Scroll-reveal + hero crossfade + vertical video play/pause.
   Cart/add is handled by Impulse natively; nothing here blocks checkout. */
(function () {
  var d = document;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal
  var rv = [].slice.call(d.querySelectorAll('.lun-rv'));
  if (rm || !('IntersectionObserver' in window)) {
    rv.forEach(function (e) { e.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (e) { io.observe(e); });
  }

  // Hero crossfade
  var sl = d.querySelector('[data-lun-slides]');
  if (sl && !rm) {
    var im = sl.querySelectorAll('img');
    if (im.length > 1) {
      var i = 0;
      setInterval(function () {
        im[i].classList.remove('is-on');
        i = (i + 1) % im.length;
        im[i].classList.add('is-on');
      }, 5200);
    }
  }

  // Free-shipping bar — live update on cart change (Impulse fires cart:updated)
  var fmtMoney = function (cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return n + ' $';
  };
  var updateFreeship = function (cart) {
    if (!cart) return;
    var el = d.querySelector('[data-lun-freeship]');
    if (!el) return;
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 10000;
    var total = cart.total_price || 0;
    if ((cart.item_count || 0) > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    var remaining = threshold - total;
    var msg = el.querySelector('[data-lun-freeship-msg]');
    var fill = el.querySelector('[data-lun-freeship-fill]');
    if (msg) {
      msg.innerHTML = remaining > 0
        ? 'Plus que <strong>' + fmtMoney(remaining) + '</strong> pour la livraison gratuite au Canada.'
        : 'Livraison gratuite au Canada débloquée.';
    }
    if (fill) { fill.style.width = Math.min(100, Math.round(total * 100 / threshold)) + '%'; }
  };
  var refreshFreeship = function () {
    if (!d.querySelector('[data-lun-freeship]')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(updateFreeship)
      .catch(function () {});
  };
  d.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) { updateFreeship(e.detail.cart); } else { refreshFreeship(); } });
  d.addEventListener('cart:build', function (e) { if (e.detail && e.detail.cart) { updateFreeship(e.detail.cart); } else { refreshFreeship(); } });
  ['ajaxProduct:added', 'product:added', 'cart:refresh', 'cart:change', 'drawerOpen'].forEach(function (ev) {
    d.addEventListener(ev, refreshFreeship);
  });
  // Most reliable trigger: Impulse rewrites the drawer subtotal on every cart change.
  var lunSubtotal = d.querySelector('[data-subtotal]');
  if (lunSubtotal && 'MutationObserver' in window) {
    new MutationObserver(refreshFreeship).observe(lunSubtotal, { childList: true, subtree: true, characterData: true });
  }
  // Sync once on load so the bar matches an already-filled cart.
  if (d.querySelector('[data-lun-freeship]')) { setTimeout(refreshFreeship, 400); }

  // Vertical video: play on view, button toggles
  var v = d.getElementById('lun-vid'), vp = d.getElementById('lun-vplay');
  if (v && vp) {
    var toggle = function () {
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    };
    var sync = function () {
      var paused = v.paused;
      vp.setAttribute('aria-pressed', paused ? 'false' : 'true');
      vp.setAttribute('aria-label', paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
      vp.style.opacity = paused ? '1' : '0';
    };
    v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
    vp.addEventListener('click', toggle); v.addEventListener('click', toggle);
    if (!rm && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          if (x.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.5 }).observe(v);
    }
  }

  // Mobile sticky add-to-cart — relays to Impulse's real [data-add-to-cart]
  var satc = d.querySelector('[data-lun-satc]');
  if (satc) {
    var realAdd = d.querySelector('[data-add-to-cart]');
    var priceEl = d.querySelector('[data-product-price]');
    var satcPrice = satc.querySelector('[data-lun-satc-price]');
    var satcBtn = satc.querySelector('[data-lun-satc-add]');
    if (realAdd) {
      satc.removeAttribute('hidden');
      if (satcBtn) {
        satcBtn.addEventListener('click', function () { realAdd.click(); });
      }
      var syncSatc = function () {
        if (priceEl && satcPrice) { satcPrice.textContent = priceEl.textContent.trim(); }
        if (satcBtn) {
          var disabled = realAdd.hasAttribute('disabled');
          satcBtn.disabled = disabled;
          if (disabled) {
            var txt = realAdd.querySelector('[data-add-to-cart-text]');
            satcBtn.textContent = txt ? txt.textContent.trim() : 'Épuisé';
          } else {
            satcBtn.textContent = 'Ajouter au panier';
          }
        }
      };
      syncSatc();
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(syncSatc);
        if (priceEl) { mo.observe(priceEl, { childList: true, subtree: true, characterData: true }); }
        mo.observe(realAdd, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      }
      d.addEventListener('variant:change', syncSatc);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (x) {
            if (x.isIntersecting) { satc.classList.remove('is-on'); }
            else { satc.classList.add('is-on'); }
          });
        }, { threshold: 0 }).observe(realAdd);
      } else {
        satc.classList.add('is-on');
      }
    }
  }
})();
